import { render } from "./localizedInput.vue?vue&type=template&id=4bebaf7e&scoped=true&ts=true"
import script from "./localizedInput.vue?vue&type=script&lang=ts"
export * from "./localizedInput.vue?vue&type=script&lang=ts"

import "./localizedInput.vue?vue&type=style&index=0&id=4bebaf7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bebaf7e"]])

export default __exports__